<div
  [aionzProductStatus]="status()"
  class="product-status">
  <mat-icon class="product-status-icon"></mat-icon>
  <span class="product-status-label">{{ label() }}</span>
</div>
